import dayjs from 'dayjs';
import {isEmpty} from "./isEmpty";

const dateUtilList = () => {
    const mainCardDateFormat = (item:any) => {
        if(isEmpty(item)) return ""
        // const parsedDate = dayjs(`${item?.slice(0,3)?.join("")}`, { format: "YYYYMMDD" });
        const formattedDate: string = dayjs(item).format("MMM DD, YYYY");
        return formattedDate;
    };

    return {
        mainCardDateFormat
    }
}
const dateUtil = dateUtilList()
export { dateUtil };
